import { Badge, Tooltip } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import type { StatusConvite } from '../types/Convites';

const TONE = { nao_enviado: 'neutral', enviado: 'info', falha: 'danger' } as const;

type Props = {
  status: StatusConvite;
  /** Motivo da falha, em português em qualquer idioma (spec 31 R16, PE18). */
  resultado?: string | null;
  /** Quem já respondeu não precisa de atenção pela falha: selo cinza (R17). */
  respondeu?: boolean;
};

export function ConviteBadge({ status, resultado, respondeu = false }: Props) {
  const { t } = useTranslation('convites');
  const tone = status === 'falha' && respondeu ? 'neutral' : TONE[status];
  // "Enviado" = aceito pelo servidor, não entregue nem lido (spec 22 D; RF-29 pela spec 31 R18).
  const dica =
    status === 'enviado' ? t('statusDica.enviado') : status === 'falha' ? resultado : null;
  if (!dica) return <Badge tone={tone}>{t(`status.${status}`)}</Badge>;
  return (
    <Tooltip content={dica}>
      <Badge tone={tone} tabIndex={0}>
        {t(`status.${status}`)}
      </Badge>
    </Tooltip>
  );
}
